
/**
 * Delegated Klaviyo signup trigger.
 * Survives Shopify AJAX cart updates.
 *
 * On mobile, the cart opens as a native modal <dialog>.
 * Native modal dialogs appear above normal HTML overlays,
 * regardless of z-index.
 *
 * Close the native dialog immediately on mobile, then let
 * the theme finish its cleanup before opening Klaviyo.
 */

const mobileCartQuery = window.matchMedia('(max-width: 989px)');

const afterNextPaint = () =>
  new Promise((resolve) => requestAnimationFrame(resolve));

// Delegated listener survives Shopify cart content updates.
document.addEventListener('click', async (event) => {
  const trigger =
    event.target instanceof Element
      ? event.target.closest('[data-klaviyo-form-id]')
      : null;

  if (!trigger) return;

  const formId = trigger.getAttribute('data-klaviyo-form-id');
  if (!formId) return;

  event.preventDefault();

  if (trigger.dataset.klaviyoOpening === 'true') return;
  trigger.dataset.klaviyoOpening = 'true';

  try {
    const drawer = trigger.closest('theme-drawer');
    const panel = drawer?.querySelector(
      'dialog.theme-drawer__dialog'
    );

    if (panel?.open) {
      if (mobileCartQuery.matches) {

        // MOBILE:
        // Immediately remove the native dialog from
        // the browser's top layer.
        panel.close();

        // Allow the theme component to clean up its
        // drawer state, scroll lock, and focus handling.
        if (typeof drawer.close !== 'function') {
          await customElements.whenDefined('theme-drawer');
        }

        if (typeof drawer.close === 'function') {
          await drawer.close();
        }

        // Allow Safari to render the closed dialog state
        // before opening the Klaviyo popup.
        await afterNextPaint();

      } else {

        // DESKTOP:
        // Preserve the existing drawer closing behavior.
        const dialogClosed = new Promise((resolve) => {
          panel.addEventListener('close', resolve, {
            once: true
          });
        });

        if (typeof drawer.close !== 'function') {
          await customElements.whenDefined('theme-drawer');
        }

        await drawer.close();

        if (panel.open) {
          await dialogClosed;
        }
      }
    }

    // Open the requested Klaviyo signup form.
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);

  } finally {
    delete trigger.dataset.klaviyoOpening;
  }
});
